import ringtoneUrl from '@/assets/ringtone.mp3'

/** One player per incoming call; stop also cancels playback still waiting for the output device. */
let audio: HTMLAudioElement | null = null
let retry: (() => void) | null = null

function clearRetry() {
  if (!retry) return
  window.removeEventListener('pointerdown', retry)
  window.removeEventListener('keydown', retry)
  retry = null
}

export function startRingtone(opts: { volume?: number; sinkId?: string | undefined } = {}) {
  if (audio) return
  const el = new Audio(ringtoneUrl)
  audio = el
  el.loop = true
  el.volume = Math.max(0, Math.min(1, opts.volume ?? 0.6))
  const play = () => {
    if (audio !== el) return
    void el.play().then(() => {
      if (audio !== el) el.pause()
      else clearRetry()
    }).catch((error: unknown) => {
      // Browsers may wait for a user gesture. Retry only while this call still rings.
      if (audio !== el || retry || !(error instanceof DOMException) || error.name !== 'NotAllowedError') return
      retry = play
      window.addEventListener('pointerdown', play)
      window.addEventListener('keydown', play)
    })
  }
  if (opts.sinkId && 'setSinkId' in el) {
    void (el as HTMLAudioElement & { setSinkId: (id: string) => Promise<void> }).setSinkId(opts.sinkId).catch(() => undefined).then(play)
  } else play()
}

export function stopRingtone() {
  clearRetry()
  const el = audio
  audio = null
  if (!el) return
  el.pause()
  el.currentTime = 0
}
